import { Fragment, useEffect } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Jobs from "./Pages/Jobs";
import Workshop from "./Pages/Workshop";
import Contact from "./Pages/Contact";
import CreateProfile from "./Pages/CreateProfile";
import Login from "./Pages/Login";
import Header from "./Layout/Nav/Header";
import Footer from "./Layout/Footer";
import Resume from "./Pages/Resume";
import Bookmarked from "./Pages/Bookmarked";
import Notifications from "./Pages/Notifications";
import ManageApplications from "./Pages/ManageApplications";
import JobAlerts from "./Pages/JobAlerts";
import AppliedEvents from "./Pages/AppliedEvents";
import EditProfile from "./Pages/EditProfile";
import JobDetails from "./Pages/JobDetails";
import CompanyDetail from "./Pages/CompanyDetail";
import Logout from "./Pages/Logout";
import BookmarkedEvent from "./Pages/BookmarkedEvent";
import RisePlans from "./Pages/RisePlans";
import Partners from "./Pages/Partners";

import "./Assets/css/linearicons.css";
import "./Assets/css/font-awesome.min.css";
import "./Assets/css/magnific-popup.css";
import "./Assets/css/nice-select.css";
import "./Assets/css/animate.min.css";
import "./Assets/css/owl.carousel.css";
import "./Assets/css/bootstrap.css";
import "./Assets/css/main.css?v";
import "./Assets/css/template.css?v";
import ProtectedRoutes from "./Utils/ProtectedRoutes";
import { useDispatch } from "react-redux";
import { checkAutoLogin } from "./Services/AuthService";


function MainLayout() {
  return (
    <Fragment>
      <Header />
      <Outlet />
      <Footer />
    </Fragment>
  );
}

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    checkAutoLogin(dispatch);
  }, [dispatch]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/workshop" element={<Workshop />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/create-profile" element={<CreateProfile />} />
        <Route path="/job-detail/:id" element={<JobDetails />} />
        <Route path="/company-detail/:id" element={<CompanyDetail />} />
        <Route path="/rise-plans" element={<RisePlans />} />
        <Route path="/partners/:id/:name" element={<Partners />} />

        {/* Auth routes  */}
        <Route element={<ProtectedRoutes />}>
          <Route path="/resume" element={<Resume />} />
          <Route path="/bookmarked" element={<Bookmarked />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/manage-applications" element={<ManageApplications />} />
          <Route path="/job-alerts" element={<JobAlerts />} />
          <Route path="/applied-events" element={<AppliedEvents />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/bookmarked-event" element={<BookmarkedEvent />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
